import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';
import { SET_ACTIVE_WIDGET, SET_DRAGGED_WIDGET, SET_LAYOUT } from '@/store/actions/layouteditor';

const state = () => ({
  layout: {},
  activeWidget: {},
  draggedWidget: {},
});

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getLayout: (state) => state.layout,
  getActiveWidget: (state) => state.activeWidget,
  getDraggedWidget: (state) => state.draggedWidget,
  getField,
};
/* eslint-enable */

const actions = {
  SET_ACTIVE_WIDGET: ({ commit }, index) => {
    commit(SET_ACTIVE_WIDGET, index);
  },
  SET_DRAGGED_WIDGET: ({ commit }, widget) => {
    commit(SET_DRAGGED_WIDGET, widget);
  },
  FETCH_LAYOUT: ({ commit }, layoutID) => {
    axios.get(`${window.api_url}api/layout/${layoutID}`)
      .then((response) => {
        commit(SET_LAYOUT, response.data.data);
      });
  },
};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  SET_ACTIVE_WIDGET: (state, index) => {
    state.activeWidget = index;
  },
  SET_DRAGGED_WIDGET: (state, widget) => {
    state.draggedWidget = widget;
  },
  SET_LAYOUT: (state, layout) => {
    state.layout = layout;
  },
  RESET_LAYOUT_STATE: (s) => {
    const initial = state();

    Object.keys(initial).forEach((key) => {
      s[key] = initial[key];
    });
  },
  updateField,
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
